import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18next from 'i18next'
import { bindActionCreators } from 'redux'
import DefaultTabs from './DefaultTabs'
import Pane from './Tab'
import KeyGenerator from "../../containers/KeyGeneratorContainer"
import InstanceHeader from "../header/InstanceHeader"

class KeyGenerationTab extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
			showFakeTab: false
	    }
	}

	componentDidMount() {
		
	}

	render() {
			return (
				<div>
					<InstanceHeader setHeader={"keyGenerationPageTitle"} />
					<div id="allTabsContainer" className="col-xs-12">
						{
							this.props.base.keyGenerator
							? <DefaultTabs selected={0}>
								{
									this.props.base.keyGenerator ? <Pane label={i18next.t("keysGeneration" : "keysGeneration")}>
										<KeyGenerator />
									</Pane> : null
								}
								{
									this.state.showFakeTab ? <Pane label={""}>
										{
											null
										}
									</Pane> : null
								}
							</DefaultTabs>
							: <h4>tmp msg</h4>
						}
					</div>
				</div>
		    );
	}
}

function mapStateToProps(state) {
    return {
        locales: state.i18n,
        localesReducer: state.localesReducer,
        connectionStatus: state.connectionStatusReucer,
        base: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    // languageSwitchItem,
	    // getSupportedCA,
	    // getConnecteds,
	    // setPassiveTokenPath,
	    // setActiveTokenPath
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(KeyGenerationTab);


// WEBPACK FOOTER //
// ./src/components/body/KeyGenerationTab.js